// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.media-library-media-svg {\n    height: calc(100vh - 24rem) !important;\n}\n.media-library__manager__content__images {\n    overflow-y: unset !important;\n}\n.media-library__manager {\n    overflow-y: scroll !important;\n}\n", ""]);
// Exports
module.exports = exports;
